/* Original Krelune sections connected to the theme's single native cart. */
(() => {
  'use strict';
  const money = cents => window.KreluneCommerce.money(cents);
  function initBuy(root) {
    if (root.dataset.krCommerceReady) return;
    root.dataset.krCommerceReady = 'true';
    const form = root.querySelector('[data-kr-pdp2form]');
    if (!form) return;
    const variants = JSON.parse(form.querySelector('[data-kr-variants]').textContent);
    const allocations = JSON.parse(form.querySelector('[data-kr-allocations]').textContent);
    const ids = new Map(variants.map(v => [String(v.id),v]));
    const tiers = [...form.querySelectorAll('[data-kr-tier]')];
    const plans = [...form.querySelectorAll('[data-kr-plan]')];
    const idInput = form.querySelector('[name=id]'), qty = form.querySelector('[name=quantity]');
    const cta = form.querySelector('[data-kr-cta]'), status = form.querySelector('[data-kr-buy-status]');
    const sticky = root.querySelector('[data-kr-original-sticky]'), stickySelect = root.querySelector('[data-kr-sticky-variant]');
    const stickyAdd = root.querySelector('[data-kr-sticky-add]');
    const originalId = idInput.value;
    let busy = false, current;
    const initialId = new URLSearchParams(location.search).get('variant');
    const initial = tiers.find(t => initialId && t.dataset.krVariant === initialId && !t.disabled) || tiers.find(t => t.checked && !t.disabled) || tiers.find(t => !t.disabled);
    if (initial) initial.checked = true;
    function sync() {
      const selected = tiers.find(t => t.checked);
      idInput.value = selected?.dataset.krVariant || originalId;
      qty.value = selected?.dataset.krVariant ? '1' : (selected?.value || '1');
      current = ids.get(idInput.value) || variants[0];
      if (!current) return;
      const list = allocations[current.id] || current.selling_plan_allocations || [];
      plans.forEach(radio => {
        const allocation = list.find(a => String(a.selling_plan?.id) === radio.value);
        radio.disabled = !!radio.value && !allocation;
        const card = radio.closest('label');
        card.hidden = radio.disabled;
        const price = card.querySelector('.kr-pdp2buy__planprice');
        if (price) price.textContent = money(allocation?.price ?? current.price);
        const was = card.querySelector('.kr-pdp2buy__planwas');
        if (was) { was.textContent = money(allocation?.compare_at_price ?? current.price); was.hidden = !(allocation?.compare_at_price > allocation?.price); }
        if (radio.checked && radio.disabled) radio.checked = false;
      });
      let plan = plans.find(p => p.checked && !p.disabled);
      if (!plan && plans[0]) { plans[0].checked = true; plan = plans[0]; }
      const planInput = form.querySelector('[name=selling_plan]');
      if (planInput) planInput.value = plan?.value || '';
      const allocation = list.find(a => String(a.selling_plan?.id) === plan?.value);
      const total = Number(allocation?.price ?? current.price) * Number(qty.value);
      const compared = Number(allocation?.compare_at_price ?? current.compare_at_price ?? 0) * Number(qty.value);
      const now = root.querySelector('[data-kr-price]'), was = root.querySelector('[data-kr-was]'), save = root.querySelector('[data-kr-save]');
      if (now) now.textContent = money(total);
      if (was) { was.textContent = money(compared); was.style.display = compared > total ? '' : 'none'; }
      if (save) { save.textContent = 'You save ' + money(compared - total); save.style.display = compared > total ? '' : 'none'; }
      cta.disabled = busy || !current.available;
      cta.setAttribute('aria-disabled', String(cta.disabled));
      cta.textContent = current.available ? `${cta.dataset.label} · ${money(total)}` : 'Sold out';
      stickySelect.value = String(current.id);
      stickyAdd.disabled = cta.disabled;
      stickyAdd.textContent = current.available ? cta.dataset.label : 'Sold out';
    }
    form.addEventListener('change', sync);
    stickySelect.addEventListener('change', () => {
      const tier = tiers.find(t => t.dataset.krVariant === stickySelect.value && !t.disabled);
      if (tier) { tier.checked = true; sync(); }
    });
    stickyAdd.addEventListener('click', () => form.requestSubmit(cta));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || cta.disabled || !form.reportValidity()) return;
      busy = true; sync(); status.hidden = true; cta.setAttribute('aria-busy','true');
      try { await window.KreluneCommerce.add(form, cta); }
      catch (error) { status.textContent = error.message || 'Please try again.'; status.hidden = false; }
      finally { busy = false; cta.removeAttribute('aria-busy'); sync(); }
    });
    sync();
    // An anchor can jump from below to above the viewport without changing the
    // IntersectionObserver ratio. Scroll fallback also covers that transition.
    let stickyFrame;
    const updateSticky = () => { stickyFrame = null; sticky.hidden = cta.getBoundingClientRect().bottom > 0; };
    const queueSticky = () => { if (!stickyFrame) stickyFrame = requestAnimationFrame(updateSticky); };
    const observer = new IntersectionObserver(updateSticky, {threshold:0});
    observer.observe(cta);
    window.addEventListener('scroll', queueSticky, {passive:true});
    window.addEventListener('resize', queueSticky, {passive:true});
    root._krCleanup = () => { observer.disconnect(); cancelAnimationFrame(stickyFrame); window.removeEventListener('scroll',queueSticky); window.removeEventListener('resize',queueSticky); };
  }
  function initRatings() {
    document.querySelectorAll('[data-kr-original-rating]').forEach(link => {
      const source = document.querySelector('.kr-revs__summary');
      const rating = Number(link.dataset.rating) || Number(source?.querySelector('.kr-revs__avg')?.textContent);
      if (!rating) return;
      link.querySelector('[data-kr-rating-label]').textContent = `${rating.toFixed(1)} / 5 · Read reviews`;
      link.setAttribute('aria-label', `${rating.toFixed(1)} out of 5. Read customer reviews`);
      link.hidden = false;
    });
  }
  function initFaq(root = document) {
    root.querySelectorAll('[data-faq-accordion]').forEach(list => {
      if (list.dataset.krReady) return;
      list.dataset.krReady = 'true';
      const items = [...list.querySelectorAll('details')];
      items.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) items.forEach(other => { if (other !== item) other.open = false; });
      }));
    });
  }
  function init(root=document) {
    root.querySelectorAll('.kr-pdp2buy').forEach(initBuy);initFaq(root);initRatings();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true}); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.kr-pdp2buy').forEach(root => root._krCleanup?.()));
})();
